__turbopack_context__.v({
  "breedLabel": "resultsPanel-module-scss-module__cnL2Va__breedLabel",
  "breedSelector": "resultsPanel-module-scss-module__cnL2Va__breedSelector",
  "calculateButton": "resultsPanel-module-scss-module__cnL2Va__calculateButton",
  "costGuideLink": "resultsPanel-module-scss-module__cnL2Va__costGuideLink",
  "resultsButtons": "resultsPanel-module-scss-module__cnL2Va__resultsButtons",
  "resultsCard": "resultsPanel-module-scss-module__cnL2Va__resultsCard",
  "resultsContainer": "resultsPanel-module-scss-module__cnL2Va__resultsContainer",
  "resultsDisplay": "resultsPanel-module-scss-module__cnL2Va__resultsDisplay",
  "resultsDisplayHeading": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayHeading",
  "resultsDisplayIcon": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayIcon",
  "resultsDisplayIconImg": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayIconImg",
  "resultsDisplayLabel": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayLabel",
  "resultsDisplayValue": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayValue",
  "resultsDisplayValues": "resultsPanel-module-scss-module__cnL2Va__resultsDisplayValues",
  "resultsFilters": "resultsPanel-module-scss-module__cnL2Va__resultsFilters",
  "resultsHeader": "resultsPanel-module-scss-module__cnL2Va__resultsHeader",
  "resultsInputs": "resultsPanel-module-scss-module__cnL2Va__resultsInputs",
  "resultsPlaceholder": "resultsPanel-module-scss-module__cnL2Va__resultsPlaceholder",
  "resultsPlaceholderIcon": "resultsPanel-module-scss-module__cnL2Va__resultsPlaceholderIcon",
  "resultsPlaceholderImg": "resultsPanel-module-scss-module__cnL2Va__resultsPlaceholderImg",
  "resultsShare": "resultsPanel-module-scss-module__cnL2Va__resultsShare",
  "resultsShareLabelHidden": "resultsPanel-module-scss-module__cnL2Va__resultsShareLabelHidden",
  "resultsSummary": "resultsPanel-module-scss-module__cnL2Va__resultsSummary",
  "selectorBlock": "resultsPanel-module-scss-module__cnL2Va__selectorBlock",
  "selectorLabel": "resultsPanel-module-scss-module__cnL2Va__selectorLabel",
  "toggleIcon": "resultsPanel-module-scss-module__cnL2Va__toggleIcon",
  "toggleIconWrap": "resultsPanel-module-scss-module__cnL2Va__toggleIconWrap",
  "toggleOption": "resultsPanel-module-scss-module__cnL2Va__toggleOption",
  "toggleOptionSelected": "resultsPanel-module-scss-module__cnL2Va__toggleOptionSelected",
  "toggleRow": "resultsPanel-module-scss-module__cnL2Va__toggleRow",
  "toggleTitle": "resultsPanel-module-scss-module__cnL2Va__toggleTitle",
  "toggleTitleSelected": "resultsPanel-module-scss-module__cnL2Va__toggleTitleSelected",
});
